
<template>
<div>
	<div v-if="isTop">
		<div class="tech_title join_link"><span @click="gomien()">公司风采<span class="el-icon-arrow-right"></span></span></div>
		<div class="join_img cur_po">
			<img @click="gomien()" src="https://tongrenhuaxue.oss-cn-shanghai.aliyuncs.com/default/b528e6701ee67a981891e1c29d01b70.jpg"/>
		</div>
		<div class="join_box" v-for="(itme,i) in postList" :key="itme.id">
			<div class="join_padd">
				<div class="tech_title">{{itme.position}}</div>
				<div class="join_zi">
					<span class="iconfont icon-weizhi"></span>
					<span class="join_li">{{itme.address}}</span>
					<span class="join_li">{{itme.category}}</span>
					<span class="join_li">招聘{{itme.number}}人</span>
					<span class="join_li">{{itme.education}}</span>
					<span class="join_li">{{itme.work_experience}}工作经验</span>
				</div>
				<div class="join_zi">
					<span class="iconfont icon-shijian"></span>
					<span class="join_li">发布于{{itme.create_time*1000 | timeFormat('yyyy-mm-dd')}}</span>
				</div>
				<el-collapse-transition>
					<div v-show="itme.isShow">
						<div>
							<div class="join_title">工作内容</div>
							<div class="join_zi" v-html="itme.work_content">
							</div>
						</div>
						<div>
							<div class="join_title">职位要求</div>
							<div class="join_zi"  v-html="itme.require">
							</div>
						</div>
					</div>
				</el-collapse-transition>
			</div>
			<div class="join_bottom">
				<span v-show="!itme.isShow" @click="setShow(i)">查看详情</span>
				<span v-show="itme.isShow" @click="setShow(i)">收起</span>
			</div>
		</div>
	</div>
	<div v-else class="mien" v-html="appearance">
		
	</div>
</div>
</template>

<script>
	export default {
		data(){
			return {
				appearance:{},
				isTop:false,
				postList:[
					{
						name:'运营经理',
						site:['上海','上海青浦区'],
						style:'运营类',
						number:1,
						education:"本科",
						undergo:'5-10年工作经验',
						time:'2020.09.23',
						isShow:false,
						children:[
							{
								name:'工作内容',
								content:['1、确保预算的有效达成；','2、通过领导技能不断提升客户服务水平','3、协调客户、供应商和运输公司之间的运作；','4、计划或监督运作流程，确保满足客户合约中的各项服务要求']
							},
							{
								name:'职位要求',
								content:['1、至少五年以上在仓库、配送或制造领域内的中高层物流管理经验，学历专业不限;','2、仓库管理系统的运用；','3、良好的口头与书面表达能力；','4、计算能力；','5、团队管理技能；','6、优秀的计划与组织能力；','7、团作协作能力；','8、良好的分析能力；','9、主动性和果断力；','10、热情。']
							}
						]
					},
					{
						name:'运营经理',
						site:['上海','上海青浦区'],
						style:'运营类',
						number:1,
						education:"本科",
						undergo:'5-10年工作经验',
						time:'2020.09.23',
						isShow:false,
						children:[
							{
								name:'工作内容',
								content:['1、确保预算的有效达成；','2、通过领导技能不断提升客户服务水平','3、协调客户、供应商和运输公司之间的运作；','4、计划或监督运作流程，确保满足客户合约中的各项服务要求']
							},
							{
								name:'职位要求',
								content:['1、至少五年以上在仓库、配送或制造领域内的中高层物流管理经验，学历专业不限;','2、仓库管理系统的运用；','3、良好的口头与书面表达能力；','4、计算能力；','5、团队管理技能；','6、优秀的计划与组织能力；','7、团作协作能力；','8、良好的分析能力；','9、主动性和果断力；','10、热情。']
							}
						]
					}
				]
			}
		},
		watch:{
			$route(ro,fro){
				this.isTop = ro.query.status!=1;
			}
		},
		created() {
			this.isTop = this.$route.query.status!=1;
			this.Postjoin();
			this.Postappearance();
		},
		methods:{
			async Postappearance(){
				let {data} = await this.api.Postappearance();
				this.appearance = data;
			},
			async Postjoin(){//获取招聘信息
				let {data} = await this.api.Postjoin();
				this.postList = data.data.map(v=>{
					v.isShow=false
					return v;
				});
			},
			setShow(i){
				this.postList[i].isShow = !this.postList[i].isShow;
			},
			gomien(){
				if(!this.$route.query.status)
				this.$router.push({ query: { status: 1 } })
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.mien{
		margin-top: 50px;
	}
	.mien_titel{
		font-size: 24px;
		font-weight: 500;
		color: #333333;
		line-height: 36px;
		text-align: center;
	}
	.mien_li{
		font-size: 24px;
		font-weight: 700;
		color: #005599;
		font-family: Weibei SC, Weibei SC-Bold;
		line-height: 30px;
	}
	.join_box{
		transition: max-height 1s;
		border: 1px solid #D9D9D9;
		margin-top: 30px;
		.join_padd{
			font-size: 16px;
			color: #8f8f8f;
			padding: 50px;
			.join_title{
				margin-top: 50px;
				font-size: 30px;
				color: #333333;
				line-height: 36px;
			}
			.tech_title{
				margin-top: 0;
			}
			.join_zi{
				margin: 10px 0;
				.join_li{
					padding: 0 5px;
				}
				.join_li2{
					color: #333;
				}
			}
		}
		.join_bottom{
			width: 100%;
			height: 70px;
			border-top: 1px dashed #D9D9D9;
			line-height: 70px;
			text-align: center;
			span{
				color: #333333;
				font-size: 20px;
				&:hover{
					cursor: pointer;
					color: #0074D9;
				}
			}
		}
		
	}
	.join_img{
		width: 100%;
		img{
			width: 100%;
		}
	}
	.join_link{
		margin-bottom: 20px ;
		font-size: 24px;
		cursor: pointer;
		color: var(--themeColor);
	}
</style>